/* eslint-disable radix */
import React, { useState } from 'react';
import CardWithTitle from 'components/CardWithTitle';
import DebounceTextInput from 'components/DebounseTextInput';
import AddAllocateVendorList from './components/AddAllocateVendorList';

const AddAllocateVendor = ({
  id,
  onCloseAddPopup,
  drawerToggle,
  roleList,
  vendorList,
}) => {
  const [searchString, setSearchString] = useState('');

  return (
    <CardWithTitle title="Vendors">
      <DebounceTextInput
        onInputChange={(val) => setSearchString(val)}
        delay={500} // Set your desired delay in milliseconds
        value={searchString}
        placeholder="Search by Vendor"
        positionRight="20px"
        positionTop="-42px"
      />
      <AddAllocateVendorList
        searchString={searchString}
        id={id}
        onCloseAddPopup={onCloseAddPopup}
        drawerToggle={drawerToggle}
        roleList={roleList}
        vendorList={vendorList}
      />
    </CardWithTitle>
  );
};

export default AddAllocateVendor;
